var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var NoCacheInterceptor = /** @class */ (function () {
    function NoCacheInterceptor() {
    }
    NoCacheInterceptor.prototype.intercept = function (req, next) {
        req = req.clone({
            setHeaders: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            }
        });
        return next.handle(req);
    };
    NoCacheInterceptor = __decorate([
        Injectable()
    ], NoCacheInterceptor);
    return NoCacheInterceptor;
}());
export { NoCacheInterceptor };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTm9DYWNoZUludGVyY2VwdG9yU2VydmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk5vQ2FjaGVJbnRlcmNlcHRvclNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUszQztJQUFBO0lBWUEsQ0FBQztJQVZVLHNDQUFTLEdBQWhCLFVBQWlCLEdBQXFCLEVBQUUsSUFBaUI7UUFDckQsR0FBRyxHQUFHLEdBQUcsQ0FBQyxLQUFLLENBQUM7WUFDWixVQUFVLEVBQUU7Z0JBQ1IsZUFBZSxFQUFFLFVBQVU7Z0JBQzNCLFFBQVEsRUFBRSxVQUFVO2dCQUNwQixTQUFTLEVBQUUsK0JBQStCO2FBQzdDO1NBQ0osQ0FBQyxDQUFDO1FBQ0gsT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQzVCLENBQUM7SUFYUSxrQkFBa0I7UUFEOUIsVUFBVSxFQUFFO09BQ0Esa0JBQWtCLENBWTlCO0lBQUQseUJBQUM7Q0FBQSxBQVpELElBWUM7U0FaWSxrQkFBa0IifQ==